import { connect } from 'react-redux';
import CreateNewVisitWhenReferrerChanges from './CreateNewVisitWhenReferrerChanges';

const mapStateToProps = state => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default connect(mapStateToProps, null)(CreateNewVisitWhenReferrerChanges);
